import type { IHttpClient } from "@/core/interfaces";
import { Registry } from "@/shared/infra/dependency-injection/registry";

import {
  cabecalhoIdempotencia,
  readEnvelopeData,
} from "../financeiro-obras/financeiro-obras.gateway";
import type {
  LookupRequestOptions,
  OpcoesMutacao,
} from "../financeiro-obras/financeiro-obras.gateway";
import type {
  AplicacaoNaObra,
  ObraDaReferencia,
  TipoReferenciaAplicavel,
} from "./financeiro-configuracoes.aplicacao-referencia.types";

export const APLICACAO_REFERENCIA_PATHS = {
  OBRAS: (tipo: TipoReferenciaAplicavel, referenciaId: string) =>
    `/api/financeiro/configuracoes/aplicacao-referencia/${tipo}/${encodeURIComponent(referenciaId)}/obras`,
  OBRA: (tipo: TipoReferenciaAplicavel, referenciaId: string, obraId: string) =>
    `/api/financeiro/configuracoes/aplicacao-referencia/${tipo}/${encodeURIComponent(referenciaId)}/obras/${encodeURIComponent(obraId)}`,
} as const;

function getHttpClient(): IHttpClient {
  return Registry.getInstance().inject<IHttpClient>("HttpClient");
}

export async function listarObrasDaReferencia(
  tipo: TipoReferenciaAplicavel,
  referenciaId: string,
  { signal }: LookupRequestOptions = {},
): Promise<ObraDaReferencia[]> {
  const response = await getHttpClient().get<unknown>(
    APLICACAO_REFERENCIA_PATHS.OBRAS(tipo, referenciaId),
    { signal },
  );
  const data = readEnvelopeData<unknown>(response.data);
  if (!Array.isArray(data)) throw new Error("Resposta inválida do bff.");

  return data as ObraDaReferencia[];
}

export async function aplicarReferenciaNaObra(
  tipo: TipoReferenciaAplicavel,
  referenciaId: string,
  obraId: string,
  { idempotencyKey }: OpcoesMutacao = {},
): Promise<AplicacaoNaObra> {
  const response = await getHttpClient().post<unknown>(
    APLICACAO_REFERENCIA_PATHS.OBRA(tipo, referenciaId, obraId),
    undefined,
    { headers: cabecalhoIdempotencia(idempotencyKey) },
  );
  return readEnvelopeData<AplicacaoNaObra>(response.data);
}
